@use "../../styling/typography.scss" as *;
@use "../../styling/colors.scss" as *;
@use '../../styling/form-controls.scss' as *;

.ErrorPlaceholder {
  @extend %font-family-primary;

  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 8px;
  border: 1px solid $color-primary-red;
  border-radius: 6px;
  font-size: $font-size-normal;
  padding: 12px 12px 10px 15px;
  color: $theme-color-text;
  background: $theme-color-error-placeholder-background;

  > div {
    padding-top: 2px;
  }

  svg {
    transform: translate(1px, 2px);

    path {
      fill: $color-primary-red;
    }
  }

  strong {
    font-weight: $font-weight-bold;
  }

  dfn {
    font-style: normal;
    color: $theme-color-text;
  }

  p {
    margin: 0;
    word-break: break-word;
  }

  pre {
    @extend %font-family-primary;

    white-space: pre-wrap;
    margin: 0;
  }
}

.ErrorMessage {
  @extend %form-control-invalid-font;

  display: grid;
  grid-template-columns: auto 1fr;
  padding: 8px 2px 0;
  font-size: $font-size-normal;
  column-gap: 4px;

  .ErrorIcon {
    align-self: baseline;
    margin-top: 3px;
  }
}
